export default __webpack_public_path__ + "static/media/maven.cdf9238c.png";